import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadAnnouncements),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doAcceptAnnouncement),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchAnnouncements);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, fork, select, put, takeEvery } from 'redux-saga/effects';
import { userAnnouncements } from 'redux/saga/entities/bound';
import { showModal, hideModal } from 'redux/modules/modals';
import { isLoggedIn, pathSelector } from 'redux/saga/selectors';
import { readSessionStorage, writeSessionStorage } from 'redux/saga/helpers/local-storage';
import { errorActionCreator } from 'redux/saga/helpers';
import { deepExtract } from 'helpers/deep';
import { error } from 'universal-logger';
var LOAD_TERMS_AND_CONDITIONS = 'LOAD_TERMS_AND_CONDITIONS';
var ACCEPT_TERMS_AND_CONDITIONS = 'ACCEPT_TERMS_AND_CONDITIONS';
var ANNOUNCEMENTS_ERROR = 'ANNOUNCEMENTS_ERROR';
export var loadAnnouncements = function loadAnnouncements() {
  return {
    type: LOAD_TERMS_AND_CONDITIONS
  };
};
export var acceptAnnouncement = function acceptAnnouncement(referenceHash) {
  return {
    type: ACCEPT_TERMS_AND_CONDITIONS,
    referenceHash: referenceHash
  };
};
export var announcementError = errorActionCreator.bind(null, ANNOUNCEMENTS_ERROR);
export function doLoadAnnouncements(client) {
  var _ref, _ref2, path, isUserLoggedIn, unseenAnnouncementsCount, isTermsPages, hasSeenAllAnnouncements, userAnnouncementsList, announcementCount;

  return regeneratorRuntime.wrap(function doLoadAnnouncements$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return all([select(pathSelector), select(isLoggedIn), call(readSessionStorage, 'unseenAnnouncements')]);

        case 3:
          _ref = _context.sent;
          _ref2 = _slicedToArray(_ref, 3);
          path = _ref2[0];
          isUserLoggedIn = _ref2[1];
          unseenAnnouncementsCount = _ref2[2];
          // Announcements should not show up on any of the terms pages
          isTermsPages = path.indexOf('/terms') !== -1;
          hasSeenAllAnnouncements = unseenAnnouncementsCount === 0;

          if (!(!isTermsPages && isUserLoggedIn && !hasSeenAllAnnouncements)) {
            _context.next = 20;
            break;
          }

          _context.next = 13;
          return call(fetchEntityIfNeeded, userAnnouncements, [client]);

        case 13:
          userAnnouncementsList = _context.sent;
          announcementCount = deepExtract('announcements.length', userAnnouncementsList, 0); // to avoid calling the the api multiple times we store the amount of unseen announcements so that we know if we should call the api the next time.

          _context.next = 17;
          return call(writeSessionStorage, 'unseenAnnouncements', announcementCount);

        case 17:
          if (!(announcementCount > 0)) {
            _context.next = 20;
            break;
          }

          _context.next = 20;
          return put(showModal('AnnouncementsModal'));

        case 20:
          _context.next = 26;
          break;

        case 22:
          _context.prev = 22;
          _context.t0 = _context["catch"](0);
          _context.next = 26;
          return call(error, 'Error loading announcements', _context.t0.message);

        case 26:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 22]]);
}
export function doAcceptAnnouncement(client, _ref3) {
  var referenceHash;
  return regeneratorRuntime.wrap(function doAcceptAnnouncement$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          referenceHash = _ref3.referenceHash;
          _context2.prev = 1;
          _context2.next = 4;
          return all([call(client.users.claimAnnouncements, [referenceHash], {
            status: 'consent'
          }), put(hideModal('AnnouncementsModal'))]);

        case 4:
          _context2.next = 10;
          break;

        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 10;
          return all([call(error, 'Error accepting announcement', _context2.t0.message), put(hideModal('AnnouncementsModal'))]);

        case 10:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 6]]);
}
export function watchAnnouncements(client) {
  return regeneratorRuntime.wrap(function watchAnnouncements$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, LOAD_TERMS_AND_CONDITIONS, doLoadAnnouncements, client);

        case 2:
          _context3.next = 4;
          return fork(takeEvery, ACCEPT_TERMS_AND_CONDITIONS, doAcceptAnnouncement, client);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}